export default {
    MENU_OPEN: 'LAYOUT_MENU_OPEN',
    MENU_CLOSE: 'LAYOUT_MENU_CLOSE',
    ACTION_STATUSES_OPEN: 'LAYOUT_ACTION_STATUSES_OPEN',
    INSTALL_BANNER_HIDE: 'LAYOUT_INSTALL_BANNER_HIDDEN',
    ADMIN_SUBMENU: 'LAYOUT_ADMIN_SUBMENU',
    ADMIN_TABLE_PARAMS: 'LAYOUT_ADMIN_TABLE_PARAMS',
    API_VERSION: 'LAYOUT_API_VERSION'
};
